import { FALLBACK_MAP_PREFERRED } from 'actiontypes/map';

export function isFallbackMapPreferred(value: boolean) {
  return { type: FALLBACK_MAP_PREFERRED, payload: { value } };
}

export default function setFallbackMapPreferred(value: boolean) {
  return (dispatch: Function) => dispatch(isFallbackMapPreferred(value));
}